import { AsyncPipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { LoadingLayerService } from '@ecs-services/loading-layer.service';
import { SewLoader } from '@sew/ui-components-angular/standalone';
import { Observable } from 'rxjs';

@Component({
    selector: 'ecs-loading-layer',
    templateUrl: './loading-layer.component.html',
    styleUrls: ['./loading-layer.component.scss'],
    imports: [SewLoader, AsyncPipe],
})
export class LoadingLayerComponent implements OnInit {
    public visible?: Observable<boolean>;

    public constructor(private loadingLayerService: LoadingLayerService) {}

    public ngOnInit(): void {
        this.visible = this.loadingLayerService.isLayerVisible();
    }
}
